module.exports = __webpack_public_path__ + "img/Leaf.a109a767.png";